<template>
  <div class="Product">
    <h2>成果物</h2>
    <p>出来た成果物などをここに置いていきます．</p>
    <ul>
      <li><a href="./product/gBooksAPI/">gBooksAPI</a></li>
      <li><a href="./product/localStrage/localStrage.html">localStrage</a></li>
      <li><a href="./product/toDoList/todo.html">toDoList</a></li>
      <li><a href="./product/BBS/">掲示板</a></li>
      <li><a href="./product/md2html/">マークダウン変換</a></li>
      <li><a href="./product/threePanelComic/sample/">3コマ漫画サンプル</a></li>
      <li>
        <a href="./product/threePanelComic/sample2/">3コマ漫画サンプル 2</a>
      </li>
      <li>
        <a href="./product/threePanelComic/sample3/">3コマ漫画サンプル 3</a>
      </li>
      <li>
        <a href="./product/firebaseTest/login.html">ログイン デモ</a>
      </li>
      <li>
        <a href="https://github.com/masa-dev/three-panel-comic-demo"
          >3コマ漫画サンプル デモ</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  title: "Product",
};
</script>
